// Default
import '../../custom/js/default';
import '../../custom/scss/components/health-index/_health-modal.scss';